import "./career.css";

const REASONS = [
  {
    icon: "fa-shield-halved",
    title: "Purpose-Driven Culture",
    text: "Be part of a mission to democratize finance and empower investors across India. Your work creates real impact.",
  },
  {
    icon: "fa-chart-line",
    title: "Growth Opportunities",
    text: "Collaborate with experts, expand your skills, and build a rewarding career in wealth management and fintech.",
  },
  {
    icon: "fa-user-group",
    title: "Collaborative Environment",
    text: "Thrive in a team-first culture that values innovation, integrity, and curiosity, where every idea is welcomed and celebrated.",
  },
  {
    icon: "fa-bullseye",
    title: "Learning & Development",
    text: "Access workshops, training programs, and mentorship to help you grow and stay ahead in your career.",
  },
  {
    icon: "fa-briefcase",
    title: "Make a Difference",
    text: "Your work directly contributes to helping individuals and businesses achieve their financial goals.",
  },
  {
    icon: "fa-heart-pulse",
    title: "Work-Life Balance",
    text: "Enjoy flexible work arrangements and supportive policies that prioritize your well-being, both personally and professionally.",
  },
  {
    icon: "fa-award",
    title: "Recognition & Rewards",
    text: "We celebrate your achievements and inspire you to reach new milestones with meaningful recognition and rewards.",
  },
  {
    icon: "fa-arrow-trend-up",
    title: "Career Advancement",
    text: "Clear career paths and performance-driven growth opportunities designed to help you achieve more.",
  },
];

export default function CareerWhy() {
  return (
    <section className="career-why">
      <div className="career-why-inner">
        <header className="career-why-head">
          <h2>Why Work With GPS Finvest?</h2>
          <p>
            We&apos;re more than a workplace – we&apos;re a community of
            passionate individuals driven by purpose, committed to excellence,
            and inspired to create real impact.
          </p>
        </header>

        <div className="career-why-grid">
          {REASONS.map((item) => (
            <article key={item.title} className="career-why-card">
              <span className="career-why-icon" aria-hidden="true">
                <i className={`fa-solid ${item.icon}`} />
              </span>
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
